import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ScreenUtilsService } from "core/services";
import { IActor } from "../../../../dto-map/i-actor";
import { RemoteSplugParametersConfigurationService } from "../../../../remotes/remote-splug-parameters-configuration.service";
import { SignProcessWizardService } from "../../../../sign-process-wizard.service";
import { ActorConfigComponent } from "./actor-config/actor-config.component";
import { IActorSplugDialogData } from "./actor-splug-info/actor-splug-info.component";


@Injectable()
export class ActorSplugInfoDialogService {

  private _dialogRef!: MatDialogRef<ActorConfigComponent>
  readonly screenSizeSubject = this._screenUtilsService.screenSizeSubject;
  get screenSize() {
    return this.screenSizeSubject.value;
  }

  constructor(
    private readonly _dialog: MatDialog,
    private readonly _signProcessWizardService: SignProcessWizardService,
    private readonly _remoteSplugParametersConfigurationService: RemoteSplugParametersConfigurationService,
    private readonly _screenUtilsService: ScreenUtilsService
  ) {

  }

  open(actor: IActor) {

    const self = this;
    this._dialogRef = this._dialog.open<
      ActorConfigComponent,
      IActorSplugDialogData,
      { [splugName: string]: { [splugKey: string]: any } }
    >(
      ActorConfigComponent,
      {
        data: {
          signProcessWizardService: this._signProcessWizardService,
          actorSplugInfoDialogService: self,
          actorId: actor?.id as string,
          actor: actor,
          remoteSplugParametersConfigurationService: this._remoteSplugParametersConfigurationService
        },
        panelClass: ['dialog-slide-from-right'],
        width: ['xs', 'sm'].includes(this.screenSize) ? '100%' : '45rem',
        height: '100%',
        position: {
          right: '0rem',
          bottom: '0rem',
          top: '0rem',
        }
      })

  }

  close() {
    this._dialogRef.close();
  }
}
